export default __webpack_public_path__ + "static/media/chance-gray.34b603b8.png";